<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <!-- <div class="page-top-wrap"> -->
            <div class="top wrap clear">
                <h2 class="bold  float-left">My Info</h2><br>
            </div>
        <!-- </div> -->
        <div class="myinfo-wrap">
            <div class="info-box clear">
                <div class="title">ID(E-mail)<span class="col-red">*</span></div>
                <div><input type="text" v-model="myinfo.uid" readonly /></div>
            </div>
            <div class="info-box clear">
                <div class="title">이름<span class="col-red">*</span></div>
                <div><input type="text" v-model="myinfo.kname" readonly /></div>
            </div>
            <div class="info-box clear">
                <div class="title">영문명</div>
                <div><input type="text" placeholder="영문명을 입력해 주세요." v-model="myinfo.ename" /></div>
            </div>
            <div class="info-box clear">
                <div class="title">E-mail</div>
                <div><input type="text" placeholder="E-mail을 입력해 주세요." v-model="myinfo.email" /></div>
            </div>
            <div class="info-box clear">
                <div class="title">비밀번호</div>
                <div>
                    <button class="btn-base-white" @click="changePw_show()">변경</button>
                    <div class="changePw" v-if="is_chnagePw">
                        <input type="password" placeholder="현재 비밀번호를 입력해 주세요." v-model="upw" />
                    </div>
                    <div class="changePw" v-if="is_chnagePw">
                        <input type="password" placeholder="새 비밀번호를 입력해 주세요." v-model="passwd" />
                    </div>
                    <div class="changePw" v-if="is_chnagePw">
                        <input type="password" placeholder="새 비밀번호를 한번 더 입력해 주세요." v-model="passwdr" />
                    </div>
                </div>
            </div>
        </div>
        <div class="changePw-info" v-if="is_chnagePw">
            <p><span class="col-red">*</span>비밀번호는 숫자+영어 대소문자+특수문자(8자 이상)으로 입력해 주세요.</p>
        </div>
        <div class="btn clear">

            <button class="btn-base-white float-left" @click="back()">취소</button>
            <button class="float-right mod" @click="updateMember()">변경하기</button>
        </div>
    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
import router from "@/router";
export default {
    name: 'MyInfo',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        myinfo: {
            kname: "",
            companyname: "",
            ename: ""
        },
        upw: "",
        passwd: "",
        passwdr: "",
        is_chnagePw: false
    }),
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    mounted() {
        //    this.doc_del_rendar();
        this.doSearch();
    },
    methods: {
        updateMember: function () {
            var num = this.passwd.search(/[0-9]/g);
            var eng = this.passwd.search(/[a-z]/ig);
            var spe = this.passwd.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
            if (this.is_chnagePw == true) {
                if (this.passwd.length < 8 || this.passwd.length > 20) {
                    alert("비밀번호는 숫자+영어 대소문자+특수문자(8자 이상)로 입력해 주세요.");
                    return false;
                } else if (this.passwd.search(/\s/) != -1) {
                    alert("비밀번호는 숫자+영어 대소문자+특수문자(8자 이상)로 입력해 주세요.");
                    return false;
                } else if (num < 0 || eng < 0 || spe < 0) {
                    alert("비밀번호는 숫자+영어 대소문자+특수문자(8자 이상)로 입력해 주세요.");
                    return false;
                }

                if (this.passwd != this.passwdr) {
                    alert("비밀번호와 비밀번호 확인이 맞지 않습니다. 다시 한번 확인해 주세요.");
                    return false;
                }
            }

            // var params = {
            //     uidx : localStorage.getItem("uidx"),
            //     ename : this.myinfo.ename,
            //     email : this.myinfo.email,
            //     is_changePw : this.is_chnagePw,
            //     upw : this.upw,
            //     passwd : this.passwd,
            //     passwdr : this.passwdr,
            //     seq : this.myinfo.seq
            // }

            var params = this.myinfo;
            params.uidx = localStorage.getItem("uidx");
            if (this.is_chnagePw == true) {
                params.is_chnagePw = 1;
            } else {
                params.is_chnagePw = 0;
            }
            params.upw = this.upw;
            params.passwd = this.passwd;
            params.passwdr = this.passwdr;

            if (confirm("내 정보를 수정하시겠습니까?") == true) {
                this.axios.post(this.$store.state.host + "/rest/mobile/myinfomod_new", params).then(function (res) {
                    // console.log(res.data);
                    if (res.data.err == 0) {
                        alert("정보 수정이 완료되었습니다.");
                        location.reload();
                    } else {
                        alert(res.data.err_msg);
                    }
                });
            }
        },
        back: function () {
            history.back();
        },
        changePw_show: function () {
            this.is_chnagePw = true;
        },
        doSearch: function () {
            console.log("search my info");
            //console.log(localStorage.getItem("uidx"));
            //console.log(localStorage.getItem("accessKey"));
            var params = {
                tmr: Date.now(),
                uidx: localStorage.getItem("uidx"),
                accessKey: localStorage.getItem("accessKey"),
            };

            var me = this;
            this.axios.get(this.$store.state.host + "/rest/mobile/myinfo_new", {
                params: params
            }).then(function (res) {
                if (res.data.err > 0) {
                    alert(res.data.err_msg);
                    if(res.data.err==213)
                      router.push("/login");
                } else {
                    me.myinfo = res.data;
                    me.myinfo.uidx = me.myinfo.seq;
                    // if(me.myinfo.ename == ""){
                    //     me.myinfo.ename = "";
                    // }
                    // if(me.myinfo.ename == ""){
                    //     me.myinfo.ename = "";
                    // }
                    // m
                }
                me.is_loader = false;
            });
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }

    // .page-top-wrap {
    //     width: 100%;

        .top {
            // padding-right: 20px;
            padding-bottom: 17px;
            padding-top: 70px;
            background: url("../assets/img/top-bg.png") no-repeat right -80px;
            background-size: 300px;
            position: relative;

            .my-reason {
                position: absolute;
                right: 0;
                bottom: 15%;
            }

            p {
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
            }

            div {
                select {
                    border: 1px solid var(--unnamed-color-53caff);
                    background: #FFFFFF 0% 0% no-repeat padding-box;
                    border: 1px solid #53CAFF;
                    border-radius: 4px;
                    opacity: 1;
                    color: #53CAFF;
                    ;
                }
            }
        // }

        .wrap {
            width: 100%;
            max-width: none;
        }

    }

    .myinfo-wrap {
        width: 90%;
        margin: 0 auto;
        max-width: 700px;
        .info-box {
            border-bottom: 1px solid #E9E9E9;
            padding-top: 20px;
            padding-bottom: 20px;

            div {
                float: left;
            }

            .title {
                width: 100px;
                text-align: left;
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                box-sizing: border-box;
                padding-left: 20px;
            }

            div {
                width: 70%;

                input[type="text"],
                input[type="password"] {
                    border-radius: 0;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                    border-bottom: none;
                    font-size: 16px;
                    padding: 0 10px;
                    width: 100%;
                    color: #000000;
                    width: 100%;
                }

                .changePw {
                    width: 100%;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #E9E9E9;

                    input[type="text"],
                    input[type="password"] {
                        font-size: 14px;
                    }

                    &:first-child {
                        padding-top: 0;
                    }

                    &:last-child {
                        border-bottom: 0;
                    }
                }
            }
        }
    }

    .changePw-info {
        width: 90%;
        margin: 0 auto;
        font-size: 14px;
        max-width: 700px;
        padding-top: 10px;
    }

    .btn {
        padding-top: 20px;
        width: 90%;
        margin: 0 auto;
        max-width: 700px;

        .mod {
            background: #53CAFF 0% 0% no-repeat padding-box;
            border-radius: 3px;
            opacity: 1;
            font-size: 14px;
            letter-spacing: 0px;
            color: #FFFFFF;
            padding: 5px 10px;
            border: none;
        }
    }
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;
    }

    .class {
        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;
            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }
        }
        .page-top-wrap {
            .wrap {
                width: 90%;
                max-width: none;
            }
        }
        .myinfo-wrap{
            width: 100%;
        }
    }
}
</style>
